
  import { Component, Vue, Prop, PropSync, Ref } from "vue-property-decorator";
  import { editFiveViscera } from "@/api/consultation";
  import { ElForm } from "element-ui/types/form";
  
  @Component({ name: 'consultation-components-add-organ' })
  export default class OrganEditDialog extends Vue {
    @PropSync("dialogVisible") visible!: boolean;
    @Prop({ default: false }) isEdit!: boolean;
    @PropSync("editData") form: any; // 编辑时传入的数据
  
    @Ref("formRef") readonly formRef!: any;
  
    rules = {
      fiveVisceraExplain: [{ required: true, message: "请输入五脏解释", trigger: "blur" }],
      visceraNurse: [{ required: true, message: "请输入五脏调养", trigger: "blur" }],
      yinInstructionInside: [{ required: true, message: "请输入阴经介绍", trigger: "blur" }],
      yangInstructionSurface: [{ required: true, message: "请输入阳经介绍", trigger: "blur" }],
      // meridianNurse: [{ required: true, message: "请输入经络调养", trigger: "blur" }],
      // common: [{ required: true, message: "请输入常见表现", trigger: "blur" }],
    };
  
    handleSave() {
      (this.$refs.formRef as any).validate((valid: boolean) => {
        if (valid) {
          editFiveViscera({ ...this.form }).then((res) => {
            this.$emit("refreshList");
            this.handleCancel();
          })
        }
      });
    }
  
    handleCancel() {
      (this.$refs.formRef as ElForm).resetFields();
      this.form = {};
      this.visible = false;
    }
  }
  